export default "__VITE_ASSET__D_fiqF1A__"